import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
import { banglaTextFormat } from "../employee/generalInfoValidation";

export const LEAVE_SETTINGS = FORM_FIELDS.LEAVE_SETTINGS;
const { SHORT_FORM, NAME, NAME_BN, MAX_DURATION } = LEAVE_SETTINGS;

export const leaveSettingsFormValidation = yup.object().shape({
  [SHORT_FORM]: yup.string().required("Short Form is Required"),
  [NAME]: yup.string().required("Name (English) is required"),
  [NAME_BN]: yup
    .string()
    .required("Name (Bangla) is required")
    .matches(banglaTextFormat, "Please provide name(In Bangla)"),
  [MAX_DURATION]: yup.string().required("Quantity is Required"),
});

export type leaveSettingsFormDataType = yup.InferType<
  typeof leaveSettingsFormValidation
>;
